@if (isActive()) {
  <div class="guide-controls" guideTopLayer role="toolbar" aria-label="Walkthrough controls">
    <!-- Previous -->
    <button
      type="button"
      class="guide-controls__btn"
      aria-label="Previous step"
      [disabled]="!canPrevious()"
      (click)="engine.previous()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m15 18-6-6 6-6" />
      </svg>
    </button>

    <!-- Play / Pause -->
    <button
      type="button"
      class="guide-controls__btn guide-controls__btn--primary"
      [attr.aria-label]="isPaused() ? 'Play walkthrough' : 'Pause walkthrough'"
      [attr.aria-pressed]="!isPaused()"
      (click)="engine.togglePlay()">
      @if (isPaused()) {
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"
          stroke="none" aria-hidden="true">
          <path d="M6 4v16l14-8z" />
        </svg>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"
          stroke="none" aria-hidden="true">
          <rect x="6" y="4" width="4" height="16" rx="1" />
          <rect x="14" y="4" width="4" height="16" rx="1" />
        </svg>
      }
    </button>

    <!-- Next -->
    <button
      type="button"
      class="guide-controls__btn"
      aria-label="Next step"
      [disabled]="!canNext()"
      (click)="engine.next()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m9 18 6-6-6-6" />
      </svg>
    </button>

    <!-- Progress -->
    <span class="guide-controls__progress" aria-live="polite">
      Step {{ stepNumber() }} of {{ totalSteps() }}
    </span>

    <span class="guide-controls__divider" aria-hidden="true"></span>

    <!-- Exit -->
    <button
      type="button"
      class="guide-controls__btn guide-controls__btn--exit"
      aria-label="Exit walkthrough"
      (click)="engine.exit()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
  </div>
}
